import styled from "styled-components";
import React from "react";

export const InputTextArea = styled.textarea`
  width: 100%;
  font-size: 16px;
  font-weight: 300;
  line-height: 19px;
  margin-bottom: 5px;
  /* height: 40px; */
  border: none;
  color: black;
  padding: 10px;
  &:focus {
    border: none;
    outline: none;
  }
`;

export const InputText = styled.input`
  width: 100%;
  font-size: 16px;
  font-weight: 300;
  line-height: 19px;
  /* margin-bottom: 5px; */
  height: 40px;
  border: none;
  color: black;
  padding: 10px;
  &:focus {
    border: none;
    outline: none;
  }
  &::placeholder {
    color: red;
  }
`;

export const InputCheckboxContainer = styled.div`
  /* margin-top: 10px; */

  .checkbox-wrapper-19 {
    box-sizing: border-box;
    --background-color: #fff;
    --checkbox-height: ${({ checkboxHeight }) => checkboxHeight || "25px"};
  }

  @-moz-keyframes dothabottomcheck-19 {
    0% {
      height: 0;
    }
    100% {
      height: calc(var(--checkbox-height) / 2);
    }
  }

  @-webkit-keyframes dothabottomcheck-19 {
    0% {
      height: 0;
    }
    100% {
      height: calc(var(--checkbox-height) / 2);
    }
  }

  @keyframes dothabottomcheck-19 {
    0% {
      height: 0;
    }
    100% {
      height: calc(var(--checkbox-height) / 2);
    }
  }

  @keyframes dothatopcheck-19 {
    0% {
      height: 0;
    }
    50% {
      height: 0;
    }
    100% {
      height: calc(var(--checkbox-height) * 1.2);
    }
  }

  @-webkit-keyframes dothatopcheck-19 {
    0% {
      height: 0;
    }
    50% {
      height: 0;
    }
    100% {
      height: calc(var(--checkbox-height) * 1.2);
    }
  }

  @-moz-keyframes dothatopcheck-19 {
    0% {
      height: 0;
    }
    50% {
      height: 0;
    }
    100% {
      height: calc(var(--checkbox-height) * 1.2);
    }
  }

  .checkbox-wrapper-19 input[type="checkbox"] {
    display: none;
  }

  .checkbox-wrapper-19 .check-box {
    height: var(--checkbox-height);
    width: var(--checkbox-height);
    background-color: var(--background-color);
    border: ${({ customBorder }) => customBorder || "calc(var(--checkbox-height) * 0.08) solid #000"};
    border-radius: ${({ borderRadius }) => borderRadius || "5px"};
    position: relative;
    display: inline-block;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -moz-transition: border-color ease 0.2s;
    -o-transition: border-color ease 0.2s;
    -webkit-transition: border-color ease 0.2s;
    transition: border-color ease 0.2s;
    cursor: pointer;
  }
  .checkbox-wrapper-19 .check-box::before,
  .checkbox-wrapper-19 .check-box::after {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    position: absolute;
    height: 0;
    width: calc(var(--checkbox-height) * 0.2);
    background-color: #34b93d;
    display: inline-block;
    -moz-transform-origin: left top;
    -ms-transform-origin: left top;
    -o-transform-origin: left top;
    -webkit-transform-origin: left top;
    transform-origin: left top;
    border-radius: 5px;
    content: " ";
    -webkit-transition: opacity ease 0.5;
    -moz-transition: opacity ease 0.5;
    transition: opacity ease 0.5;
  }
  .checkbox-wrapper-19 .check-box::before {
    top: calc(var(--checkbox-height) * 0.72);
    left: calc(var(--checkbox-height) * 0.41);
    box-shadow: 0 0 0 calc(var(--checkbox-height) * 0.05) var(--background-color);
    -moz-transform: rotate(-135deg);
    -ms-transform: rotate(-135deg);
    -o-transform: rotate(-135deg);
    -webkit-transform: rotate(-135deg);
    transform: rotate(-135deg);
  }
  .checkbox-wrapper-19 .check-box::after {
    top: calc(var(--checkbox-height) * 0.37);
    left: calc(var(--checkbox-height) * 0.05);
    -moz-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }

  .checkbox-wrapper-19 input[type="checkbox"]:checked + .check-box,
  .checkbox-wrapper-19 .check-box.checked {
    border-color: #34b93d;
  }
  .checkbox-wrapper-19 input[type="checkbox"]:checked + .check-box::after,
  .checkbox-wrapper-19 .check-box.checked::after {
    height: calc(var(--checkbox-height) / 2);
    -moz-animation: dothabottomcheck-19 0.2s ease 0s forwards;
    -o-animation: dothabottomcheck-19 0.2s ease 0s forwards;
    -webkit-animation: dothabottomcheck-19 0.2s ease 0s forwards;
    animation: dothabottomcheck-19 0.2s ease 0s forwards;
  }
  .checkbox-wrapper-19 input[type="checkbox"]:checked + .check-box::before,
  .checkbox-wrapper-19 .check-box.checked::before {
    height: calc(var(--checkbox-height) * 1.2);
    -moz-animation: dothatopcheck-19 0.4s ease 0s forwards;
    -o-animation: dothatopcheck-19 0.4s ease 0s forwards;
    -webkit-animation: dothatopcheck-19 0.4s ease 0s forwards;
    animation: dothatopcheck-19 0.4s ease 0s forwards;
  }
`;

export const InputTextAreaEditorContainer = styled.div`
  .ck-editor__editable {
    border: none;
    height: fit-content !important;
  }

  .ck.ck-content {
    min-height: 0px !important;
  }

  .ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content {
    border: none;
  }

  .ck.ck-button {
    padding: 0px 3px !important;
  }
  .ck.ck-icon {
    font-size: 12px !important;
    width: 14px !important;
    height: 14px !important;
  }
`;

const CheckboxContainer = styled.div`
  .checkbox-login {
    --bg: #fff;
    --brdr: #293134;
    --brdr-actv: #1e2235;
    --brdr-hovr: #bbc1e1;
    --dur: calc((var(--size, 2) / 2) * 0.6s);
    display: inline-block;
    width: calc(var(--size, 1) * 18px);
    position: relative;
  }

  .checkbox-login:after {
    content: "";
    width: 100%;
    padding-top: 100%;
    display: block;
  }

  .checkbox-login > * {
    position: absolute;
  }

  input {
    -webkit-appearance: none;
    -moz-appearance: none;
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
    background-color: var(--bg);
    border-radius: calc(var(--size, 1) * 4px);
    border: calc(var(--newBrdr, var(--size, 1)) * 1px) solid;
    color: var(--newBrdrClr, var(--brdr));
    outline: none;
    margin: 0;
    padding: 0;
    transition: all calc(var(--dur) / 3) linear;
  }

  input:hover,
  input:checked {
    --newBrdr: calc(var(--size, 1) * 2);
  }

  input:hover {
    --newBrdrClr: var(--brdr-hovr);
  }

  input:checked {
    --newBrdrClr: var(--brdr-actv);
    transition-delay: calc(var(--dur) / 1.3);
  }

  input:checked + svg {
    --dashArray: 16 93;
    --dashOffset: 109;
  }

  svg {
    fill: none;
    left: 0;
    pointer-events: none;
    stroke: var(--stroke, var(--brdr-actv));
    stroke-dasharray: var(--dashArray, 93);
    stroke-dashoffset: var(--dashOffset, 94);
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 2px;
    top: 0;
    transition: stroke-dasharray var(--dur), stroke-dashoffset var(--dur);
  }

  svg,
  input {
    display: block;
    height: 100%;
    width: 100%;
  }
`;

export const CheckboxLogin = ({ name, id, value, onChange }) => (
  <CheckboxContainer>
    <div className="checkbox-login">
      <input type="checkbox" name={name} id={id} value={value} onChange={onChange} />
      <svg>
        <use xlinkHref="#checkbox-30" className="checkbox" />
      </svg>
    </div>
    <svg xmlns="http://www.w3.org/2000/svg" style={{ display: "none" }}>
      <symbol id="checkbox-30" viewBox="0 0 22 22">
        <path
          fill="none"
          stroke="currentColor"
          d="M5.5,11.3L9,14.8L20.2,3.3l0,0c-0.5-1-1.5-1.8-2.7-1.8h-13c-1.7,0-3,1.3-3,3v13c0,1.7,1.3,3,3,3h13 
          c1.7,0,3-1.3,3-3v-13c0-0.4-0.1-0.8-0.3-1.2"
        />
      </symbol>
    </svg>
  </CheckboxContainer>
);
